import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  getFirestore,
  memoryLocalCache,
} from "firebase/firestore";
import { getAuth, initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, browserPopupRedirectResolver } from "firebase/auth";

const customAuthDomain = "auth.snix.mkdevprojects.co.za";
const configuredAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN?.trim();

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCNf0irsu8Vm3rxwAKLwMS_B_847eUDSww",
  // Keep the web auth handler on SNIX's custom domain. The legacy Firebase
  // project domain is intentionally rejected so a stale build-time variable
  // cannot silently send users back to firebaseapp.com.
  authDomain:
    configuredAuthDomain && configuredAuthDomain !== "snix-2a816.firebaseapp.com"
      ? configuredAuthDomain
      : customAuthDomain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "snix-2a816",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "snix-2a816.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "860805859882",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:860805859882:web:eeb7cd7d18a296cf1ad153",
};

export const isFirebaseConfigured = true;

const app = (() => {
  try {
    return initializeApp(firebaseConfig);
  } catch (err) {
    console.error("[SNIX] initializeApp failed:", err);
    return null;
  }
})();

// Auth with IndexedDB persistence so login survives app restarts
export const auth = (() => {
  if (!app) return null as any;
  try {
    return initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
      // Required when using custom initializeAuth — without this, signInWithPopup
      // and signInWithRedirect both throw auth/argument-error.
      popupRedirectResolver: browserPopupRedirectResolver,
    });
  } catch {
    // Already initialized
    try { return getAuth(app); } catch (e) { console.error("[SNIX] getAuth failed:", e); return null as any; }
  }
})();

// Firestore with memory cache — write errors (e.g. security-rule rejections) surface
// immediately instead of being silently swallowed by offline persistence queuing.
export const db = (() => {
  if (!app) return null as any;
  try {
    return initializeFirestore(app, {
      localCache: memoryLocalCache(),
    });
  } catch {
    // Already initialized — fall back to basic
    try { return getFirestore(app); } catch (e) { console.error("[SNIX] getFirestore failed:", e); return null as any; }
  }
})();

import { getStorage } from "firebase/storage";
export const storage = (() => {
  if (!app) return null as any;
  try { return getStorage(app); } catch (e) { console.error("[SNIX] getStorage failed:", e); return null as any; }
})();

export default app!;
